import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BrowserTolerance from '../components/Proctor/BrowserTolerance';
import {
  hideBrowserToleranceModal,
  showBrowserToleranceModal,
  decrementBrowserToleranceCount,
  initializeBrowserTolerance,
} from '../actions/proctor';
import { submitTest } from '../actions/test';

const mapStateToProps = state => {
  return {
    test: state.test,
    auth: state.auth,
    testSolutionSet: state.testSolutionSet,
    browserToleranceCount: state.proctor.browserToleranceCount,
    showMultiSession: state.socket.showMultiSession,
    attemptedProblems: state.appStatus.attemptedProblems,
    leaveTestViolation: state.proctor?.leaveTestViolation,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      hideBrowserToleranceModal,
      showBrowserToleranceModal,
      decrementBrowserToleranceCount,
      initializeBrowserTolerance,
      submitTest,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowserTolerance);
